import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'

// Styles
import classes from './Product.scss'

// Actions
import { orderActions, productActions, userActions } from 'redux/actionCreators'

// Components
import { Pagination, Heading, UserSearchbox, ProductItem, Loader, NotFound } from 'components'

// Helpers
import { get, omit, isEqual, pickBy, identity } from 'lodash'
import { pageFromProps, offset } from 'helpers/utilities'
import queryString from 'query-string'

const mapStateToProps = (state) => ({
  searchState: get(state, ['app', 'searchState']),
  loading: get(state, 'product.findAttempting') || false,
  products: get(state, ['product', 'products']) || [],
  productCode: get(state, 'product.product.productCode') || '',
  pageCount: get(state, ['product', 'pageCount']) || 0,
  cartProductMap: get(state, ['order', 'cartProductMap']) || {},
  companyOptions: get(state, ['company', 'companyOptions']) || [],
  tagOptions: get(state, ['product', 'tagOptions']) || [],
  userClass: get(state, ['user', 'me', 'userClass']) || 0,
  aggregateResult: get(state, 'product.aggregateResult') || []
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  saveSearchState: (searchState) =>
    dispatch({ type: 'SAVE_SEARCH_STATE', searchState }),
  attemptFindProducts: (payload = {}) =>
    dispatch(productActions.attemptFindProducts({
      ...payload,
      unitId: 0,
      offset: payload.offset,
      limit: 100
    })),
  attemptAggregate: (payload = {}) =>
    dispatch(productActions.attemptAggregate(payload)),
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode }))
})

@connect(mapStateToProps, mapDispatchToProps)
class Products extends Component {
  state = {
    currentQuery: {
      barcode: '',
      genericName: '',
      productCode: '',
      productName: ''
    }
  };
  static propTypes = {
    products: PropTypes.array.isRequired,
    pageCount: PropTypes.number.isRequired,
    cartProductMap: PropTypes.object.isRequired,
    companyOptions: PropTypes.array.isRequired,
    tagOptions: PropTypes.array.isRequired,
    userClass: PropTypes.number.isRequired,

    attemptFindProducts: PropTypes.func.isRequired,
    attemptAddToCart: PropTypes.func.isRequired
  };
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentDidMount () {
    window.objectFitImages()
    if (this.props.productCode) {
      setTimeout(() => {
        const row = document.getElementById(this.props.productCode)
        if (!row) return
        const { top } = offset(row)
        window.scrollTo(0, top - 200)
      }, 500)
    }
  }

  componentWillMount () {
    const query = {
      barcode: get(this.props, 'location.query.keyword'),
      productCode: get(this.props, 'location.query.keyword'),
      productName: get(this.props, 'location.query.keyword'),
      description: get(this.props, 'location.query.keyword'),
      genericName: get(this.props, 'location.query.keyword'),
      companyCode: get(this.props, 'location.query.companyCode'),
      category: get(this.props, 'location.query.category'),
      offset: (pageFromProps(this.props) - 1) * 100
    }
    this.props.attemptFindProducts(query)
    this.props.attemptAggregate(query)
  }

  _renderProduct = (product) =>
    <div key={product.productCode} className={classes.productItemWrapper}>
      <ProductItem
        product={product}
        amount={get(this.props, ['cartProductMap', `${product.productCode}-0`, 'amount'])}
        userClass={this.props.userClass}
        onAddToCart={this.props.attemptAddToCart}
        onAddToWishlist={this.props.attemptAddToWishlist}
        onRemoveFromWishlist={this.props.attemptRemoveFromWishlist} />
    </div>

  _cleanQuery = (query) =>
    omit(pickBy(query, identity), ['page', 'offset']);

  _onQuery = (query) => {
    const { pathname } = this.props.location
    const { keyword, companyCode, category, page } = query
    const fields = pickBy({ keyword, companyCode, category, page }, identity)
    if (!isEqual(this._cleanQuery(this.state.currentQuery), this._cleanQuery(query))) {
      this.setState({ currentQuery: query })
      this.context.router.push(`${pathname}?${queryString.stringify({ ...fields, page: 1 })}`)
    } else {
      this.context.router.push(`${pathname}?${queryString.stringify(fields)}`)
    }

    this.props.attemptFindProducts(query)
    this.props.attemptAggregate(query)
  }

  render () {
    const { searchState, loading, location, pageCount, products, companyOptions, tagOptions, aggregateResult } = this.props
    return (
      <section className={classes.products}>
        <Helmet title='สินค้า' />
        <Heading withSearchbox>สินค้า</Heading>
        <UserSearchbox
          searchState={searchState}
          onSearchStateSave={this.props.saveSearchState}
          onQuery={this._onQuery}
          query={location.query}
          offset={(pageFromProps(this.props) - 1) * 100}
          companyOptions={companyOptions}
          tagOptions={tagOptions}
          aggregateResult={aggregateResult} />
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        {pageCount ? (
          <div className={classes.productItemsContainer}>
            {products.map(this._renderProduct)}
          </div>
        ) : !loading ? <NotFound /> : <Loader blue />}
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
      </section>
    )
  }
}

export default Products



/** WEBPACK FOOTER **
 ** ./src/containers/User/Product/Products.js
 **/